export default "__VITE_ASSET__aZM5sFo___"